/*
 *
 * ShelvesHeightSelector
 *
 */

import React from 'react';
import Img from 'components/Img';
import sizeHeight from 'assets/images/size/height.svg';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { getBestCommonShelfValue } from 'containers/Ribbon/ShelvesRibbon/utils';
import { useTranslation } from 'react-i18next';
import KewloxSlider from 'components/KewloxSlider';

interface Props {
  icon: any;
  handleInput: Function;
  min?: number;
  max?: number;
  marks?: any;
  commonHeight: number | undefined;
  allShelves: boolean;
  shelvesSelected: Shelf[];
  custom?: boolean;
}

function ShelfHeightSelector({
  icon,
  commonHeight,
  handleInput,
  allShelves,
  shelvesSelected,
  custom,
  ...sliderOptions
}: Props) {
  const handleSliderChange = (event: any, newValue: any, preview: boolean) => {
    handleInput(newValue, preview);
  };
  const { t } = useTranslation();

  let heightValue: number | string = '(*)';
  if (typeof commonHeight !== 'undefined') {
    if (custom) {
      heightValue = commonHeight;
    } else {
      heightValue = commonHeight / 10;
    }
  }

  return (
    <div className="flex flex-col items-center justify-center lg:justify-between w-full mx-2 lg:mx-0 cursor-pointer text-gray-800">
      <div className="sethidden lg:flex items-center">
        <div className="my-0 py-0 h-10 w-10">
          <Img src={sizeHeight} alt="height shelves" />
        </div>
        <div className="my-0 py-0 -mt-1 ml-2 text-lg">
          {heightValue}{' '}
          <span className="text-base">{!custom ? 'cm' : 'mm'}</span>
        </div>
      </div>
      <div className="flex w-full justify-center items-center">
        <div className="lg:hidden -mt-1 h-16 w-16 mr-2 flex justify-end">
          <Img src={sizeHeight} alt="height shelves" />
        </div>
        <div className="flex-grow flex-shrink max-w-2xl min-h-0">
          {typeof commonHeight !== 'undefined' ? (
            <KewloxSlider
              value={commonHeight}
              onChange={(e, value) => handleSliderChange(e, value, true)}
              onChangeCommitted={(e, value) =>
                handleSliderChange(e, value, false)
              }
              aria-labelledby="input-slider"
              valueLabelDisplay="auto"
              valueLabelFormat={(e: number, index: number) => `${e / 10}`}
              step={null}
              marks
              {...sliderOptions}
            />
          ) : (
            <button
              className="text-xs border py-1 px-1"
              onClick={() => {
                handleInput(
                  getBestCommonShelfValue(shelvesSelected.map(s => s.height)),
                );
              }}
            >
              {t('Select height for')}{' '}
              {allShelves ? t('all the') : `${shelvesSelected.length}`}{' '}
              {t('shelves')}
            </button>
          )}
        </div>
        <div className="lg:hidden ml-2 my-0 py-0 -mt-1">
          {heightValue} <span className="text-xs">{!custom ? 'cm' : 'mm'}</span>
        </div>
      </div>
      {/*<FiChevronDown />*/}
    </div>
  );
}

export default ShelfHeightSelector;
